/* 🤖 this file was generated by svg-to-ts */
export var spxIconClose = {
    name: 'close',
    data: "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\"><path d=\"M6 6L18 18\" stroke-width=\"2\" stroke-linecap=\"round\"/><path d=\"M18 6L6 18\" stroke-width=\"2\" stroke-linecap=\"round\"/></svg>"
};
